import { SubscriptionPlan, SubscriptionPlanName } from "@arelia-types/subscriptions";

export const FANS_NAV_OPTS = [
  { value: "/my-fans/dashboard", label: "Dashboard" },
  { value: "/my-fans/list", label: "Fans" },
  { value: "/my-fans/campaigns/list", label: "Campaigns" },
  { value: "/my-fans/settings", label: "Settings" }
];
export const planSupportsMyFans = (plan?: SubscriptionPlan) => {
  return [SubscriptionPlanName.MySocialMyFans, SubscriptionPlanName.Free].includes(plan as SubscriptionPlanName);
}

export const getFansNavOptions = (
  { EnableMyFans, EnableTwilio }: { EnableMyFans?: boolean, EnableTwilio?: boolean },
  plan?: SubscriptionPlan
) => {
  if (!planSupportsMyFans(plan))
    return [FANS_NAV_OPTS[0]];

  const navOptions = EnableMyFans ?
    FANS_NAV_OPTS.map((opt) => ({
      ...opt,
      disabled: false
    })) : [FANS_NAV_OPTS[0]];

  if (!EnableTwilio && EnableMyFans) {
    navOptions.pop();
  }

  return navOptions;
}